export default __webpack_public_path__ + "static/media/mahfuz-resume.c76e1211.pdf";